exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.stars, span.stars span {\r\n    display: block;\r\n   /* Download the star image here: http://stackoverflow.com/questions/1987524/turn-a-number-into-star-rating-display-using-jquery-and-css */\r\n    background: url('https://apppresser.com/wp-content/uploads/2015/11/stars.png') 0 -16px repeat-x;\r\n    width: 80px;\r\n    height: 16px;\r\n  }\r\n  \r\n  span.stars span {\r\n    background-position: 0 0;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/phoneinfo2/phoneinfo/src/app/components/findphones/findphones.component.css
// module id = ../../../../../src/app/components/findphones/findphones.component.css
// module chunks = main